
const ProductQty = {
  init() {
     
    
    const btnLess = document.querySelector('product-qty button.less')
    const btnAdd = document.querySelector('product-qty button.add')
    const inputQty = document.querySelector('product-qty input')
    
    if (null == btnLess) return

    console.log(btnLess, btnAdd, inputQty.max, inputQty.value)
      const maxValue = parseInt(inputQty.max)
    
      console.log('aaaaa', btnLess)
      btnLess.addEventListener('click', (e) => {
        e.preventDefault()
        console.log('----', Math.max(1, parseInt(inputQty.value, 10) - 1))
        inputQty.value = Math.max(1, parseInt(inputQty.value, 10) - 1)
      })
    
      console.log('ssss', btnAdd)
      btnAdd.addEventListener('click', (e) => {
        e.preventDefault()
        console.log('+++++', Math.min(maxValue, parseInt(inputQty.value, 10) + 1))
        inputQty.value = Math.min(maxValue, parseInt(inputQty.value, 10) + 1)
      })
    
  }
}

const Product = {
  init(){
    const addToCartBtn = document.querySelector('product-buttons .add-to-cart')
    const quoteBtn = document.querySelector('product-buttons .quote')
    const consultancyBtn = document.querySelector('product-buttons .consultancy')

    if (null != addToCartBtn) {
      addToCartBtn.addEventListener('click', (e) => {
        e.preventDefault()
        document.dispatchEvent(new CustomEvent(Cart.ADD, { detail: { productId: e.target.dataset.variantId, quantity: document.querySelector('product-qty input').value, btn: addToCartBtn } }))
      })
    }

    if (null != quoteBtn) {
      quoteBtn.addEventListener('click', (e) => {
        e.preventDefault()
        Modal.open()
      })
    }
    
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const productMediaMain = new Swiper('.product-media-main-image', {
    loop: false,
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
    },
    on: {
      slideChange: function (e) {
        const thumbnails = document.querySelectorAll('.product-media-thumbnails ul li')
        thumbnails.forEach(el => el.classList.remove('selected'))
        thumbnails[this.activeIndex].classList.add('selected')

        document.querySelectorAll('.product-media-main video').forEach(video => {
          video.pause()
        })

        document.querySelectorAll('.product-media-main iframe').forEach(frame => {
          frame.src = frame.src
        })
      },
    }
  })
  document.querySelectorAll('.product-media-thumbnails ul li').forEach((el, index) => {
    el.addEventListener('click', () => {
      productMediaMain.slideTo(index, 0)
    })
  })
  
      
  ProductQty.init()
  Quote.init()
  Modal.init()
  Product.init()
})